import React, {Component} from 'react';
import axios from 'axios';
import inputValidation from '../services/inputValidation';
import '../style/SignUp.css';
import {Link} from 'react-router-dom';

import PayBtn from './PayBtn';
import Pricing from './Pricing';

class SignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      password: '',
      passwordConfirm: '',
      paymentMessage: null,
      nonce: null,
      res: null,
      submitError: null,
      submitting: false,
      confirmPaymentInformation: false,
      paymentOption: 20,
      optIn: true,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.generateInputs = this.generateInputs.bind(this);
    this.nonceHandler = this.nonceHandler.bind(this);
    this.setPaymentOption = this.setPaymentOption.bind(this);
    this.handleOptIn = this.handleOptIn.bind(this);
  }
  async handleSubmit(event) {
    event.preventDefault();
    this.setState({submitting: true});
    const {
      name,
      email,
      password,
      passwordConfirm,
      nonce,
      paymentOption,
      optIn,
    } = this.state;
    // `inputValdiation()` will return `null` if there are no errors. Otherwise, it'll report the first error it sees.
    const inputError = inputValidation({
      name,
      email,
      password,
      passwordConfirm,
    });
    if (inputError) {
      return this.setState({submitError: inputError, submitting: false});
    }
    if (!inputError) {
      // let's clear any left over messages
      this.setState({submitError: null});
    }
    if (!this.state.nonce) {
      return this.setState({submitError: 'Please enter payment information'});
    }
    const createUserUrl =
      'https://qeyrfqi5id.execute-api.us-east-1.amazonaws.com/dev/users/create';
    const reqBody = {
      name,
      email,
      password,
      nonce,
      paymentOption,
      optIn,
    };
    try {
      await axios.post(createUserUrl, reqBody);
      const processPaymentUrl =
        'https://agile-ocean-79433.fly.dev/pay/nonce-handler';
      const proccessPaymentBody = {
        price: this.state.paymentOption,
        nonce: this.state.nonce,
      };
      const paymentResult = await axios.post(
        processPaymentUrl,
        proccessPaymentBody
      );
      // console.log("paymentResult", paymentResult);
      if (paymentResult.data.success) {
        this.setState({
          submitting: false,
          res: 'Great! All you need to do is check your email!',
        });
      }
    } catch (error) {
      this.setState({submitting: false});
      const {status} = error;
      if (status === 422) {
        this.setState({
          submitError:
            'Hey, this email is already in use! You can reset your password at /forgot-password. No worries, this transaction was NOT processed.',
        });
      } else {
        console.log(error.response);
        this.setState({
          submitError:
            'Something went wrong. No worries through, this transaction was NOT processed',
        });
      }
    }
  }
  nonceHandler(nonce) {
    this.setState({nonce});
  }
  generateInputs(inputsArr) {
    return inputsArr.map(input => {
      return (
        <div key={input.name} className="input-holder">
          <label
            className={this.state[input.name] ? 'helper-active' : 'helper'}
          >
            {input.placeholder}
          </label>
          <input
            onChange={e => {
              const stateKey = input.name;
              const stateObj = {};
              stateObj[stateKey] = e.target.value;
              this.setState(stateObj);
            }}
            className="sign-input"
            placeholder={input.placeholder}
            name={input.className}
            type={input.type}
            value={this.state[input.name]}
          />
        </div>
      );
    });
  }

  setPaymentOption(num) {
    this.setState({
      paymentOption: num,
    });
  }

  handleOptIn(e) {
    this.setState(currState => ({
      optIn: !currState.optIn,
    }));
  }

  render() {
    const inputsToBeGenerated = [
      {
        name: 'name',
        type: 'text',
        placeholder: 'First name',
      },
      {
        name: 'email',
        type: 'text',
        placeholder: 'Email',
      },
      {
        name: 'password',
        type: 'password',
        placeholder: 'Password with 6 or more characters',
      },
      {
        name: 'passwordConfirm',
        type: 'password',
        placeholder: 'Confirm your password',
      },
    ];
    return (
      <div>
        <h1 className="form-message">Sign up</h1>
        <p style={{padding: '0px 1rem'}}>
          Sign up for lifetime access to complete scores—new motets will be
          added continuely.{' '}
          <Link to="/contact/#information">
            Click here to learn more about our policies.
          </Link>
        </p>
        {this.state.submitError && (
          <div className="error-message">
            <p>{this.state.submitError}</p>
          </div>
        )}
        {!this.state.res && (
          <form onSubmit={this.handleSubmit}>
            {this.generateInputs(inputsToBeGenerated)}
            <div className="opt-in">
              <label>
                <input
                  type="checkbox"
                  onChange={this.handleOptIn}
                  checked={this.state.optIn}
                />
                {this.state.optIn ? 'I do want' : "I don't want"} occasional
                emails from englishmotets.com
              </label>
            </div>
            <div className="submit-btn">
              {!this.state.confirmPaymentInformation &&
                this.state.nonce &&
                !this.state.submitting && (
                  <button
                    // onClick={e => this.setState({ submitting: true })}
                    className="btn"
                    type="submit"
                  >
                    {`Click here to submit payment: $${this.state.paymentOption}`}
                  </button>
                )}

              {this.state.submitting && (
                <div className="spinner spinner-5">
                  <span />
                  <span />
                  <span />
                </div>
              )}
            </div>
          </form>
        )}
        {this.state.res && (
          <div className="success-message">
            <p>{this.state.res}</p>
          </div>
        )}
        <div>
          {this.state.paymentSuccess && (
            <div className="success-message">
              <p>{this.state.paymentMessage}</p>
            </div>
          )}

          <Pricing setPaymentOption={this.setPaymentOption} />
          <PayBtn
            priceToPay={20}
            showSubmit={this.state.nonce ? false : true}
            nonceHandler={this.nonceHandler}
          />
        </div>
      </div>
    );
  }
}

export default SignUp;



// WEBPACK FOOTER //
// ./src/components/SignUp.js